import React, { useState, useEffect } from "react";
import "./avatarUpdate.scss";
import { IconButton } from "@mui/material";
import edit from "../../Assets/images/Edit.svg";
import { getCookie, parseCookieJson } from "../../Functions/cookieFunction";
const ImgUpload = ({
  onChange,
  src
}) =>
  <label htmlFor="photo-upload" className="custom-file-upload fas">
    <div className="img-wrap img-upload" >
      <img htmlFor="photo-upload" src={src} />
      
    </div>
    <input id="photo-upload" type="file" onChange={onChange} />
    <span className="changeProfileLogo" > <img   src={edit} alt="" srcSet="" /></span>
   
  </label>


const Profile = ({
  onSubmit,
  src,
  name,
  status,
}) =>
  <div className="card">
    <form onSubmit={onSubmit}>

      <label className="custom-file-upload fas">
        <div className="img-wrap" >
          <img htmlFor="photo-upload" src={src} />
        </div>
      </label>
    </form>
  </div>


const Edit = ({
  onSubmit,
  children,
}) =>
  <div className="card">
    <form onSubmit={onSubmit}>
      {children}
    </form>
  </div>




const CardProfile = ({ handleGetImgUrl,appState }) => {

  const [file, setFile] = useState("")
  const [imagePreviewUrl, setImagePreviewUrl] = useState("")
  const [active, setActive] = useState("edit")
  // console.log(appState)

  const photoUpload = e => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      setFile(file);
      setImagePreviewUrl(reader.result)
    }
    reader.readAsDataURL(file);
  }

  const handleSubmit = e => {
    e.preventDefault();
    let activeP = active === 'edit' ? 'profile' : 'edit';
    setActive(activeP)
  }

  useEffect(() => {
    handleGetImgUrl(file, imagePreviewUrl)
    // console.log(file, imagePreviewUrl)
  }, [file, imagePreviewUrl])

  useEffect(() => {
    let localProfile = parseCookieJson(getCookie("Profile")) || {};
     
    if(localProfile.image !== "" ){
      setImagePreviewUrl(localProfile.image)
    }
  }, [])

  

  return (
    <div id="avatarUpdate">
      {(active === 'edit') ? (
        <Edit onSubmit={handleSubmit}>
          <ImgUpload onChange={photoUpload} src={imagePreviewUrl} />
        </Edit>
      ) : (
        <Profile
          onSubmit={handleSubmit}
          src={imagePreviewUrl}
        />)}

    </div>
  )
}



export default CardProfile;
